<template>
	<div class="ds-empty-state">
		<i v-if="icon" class="ds-empty-state__icon la" :class="'la-' + icon" />
		<p class="ds-empty-state__title">{{ title }}</p>
		<p v-if="description" class="ds-empty-state__text">{{ description }}</p>
		<div v-if="$slots.default" class="ds-empty-state__action">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: "OvEmptyState",
	props: {
		title: { type: String, default: "No results found" },
		description: { type: String, default: "" },
		icon: { type: String, default: "inbox" },
	},
};
</script>

<style scoped>
.ds-empty-state__action {
	margin-top: var(--ds-space-4);
}
</style>
